import { render, staticRenderFns } from "./empty-learning.vue?vue&type=template&id=2acb589e&scoped=true"
import script from "./empty-learning.vue?vue&type=script&lang=js"
export * from "./empty-learning.vue?vue&type=script&lang=js"
import style0 from "./empty-learning.vue?vue&type=style&index=0&id=2acb589e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb589e",
  null
  
)

export default component.exports